import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.EditingPermissionCell', {
    editingMatrix: 'Editing matrix',
    cannotEditAnyField: 'cannot edit any field',
    canEditXFields: 'can edit {qty} field(s)',
});
